<template>
  <div class="userInfo">
    <base-title title="基本信息">
      <el-button
        type="primary"
        @click="goBack()"
      >返回上一级</el-button>
    </base-title>
    <UserEditor
      :params="params"
      :type="type"
      :status.sync="saveStatus"
      @saveEdit="saveEdit"
      ref="userEditor"
    ></UserEditor>
  </div>
</template>

<script>
import { dealerDetail, saveDealerEdit } from 'index/api'
import UserEditor from '../components/userEditor'
export default {
  name: 'userDetail',
  data () {
    return {
      type: '', // 1 是查看页面
      query: {
        page: 1,
        pageSize: 10
      },
      total: 0,
      list: [],
      tableLoading: true,
      params: {
        role_id: '',
        phone: '',
        nickname: '',
        email: '',
        region_id: '',
        status: '',
        password: '',
        confirm_password: '',
        id_number: '',
        created_at: '',
        id: ''
      },
      id: '',
      saveStatus: false
    }
  },
  components: {
    UserEditor
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    async loadUserData () {
      let params = { id: Number(this.id) }
      let res = await dealerDetail(params)
      let { success, rows = {} } = res
      if (success) {
        Object.keys(this.params).forEach(item => {
          this.params[item] = rows.detail[item]
        })
      }
    },
    async saveEdit () {
      let params = { ...this.params, id: this.params.id }
      let res = await saveDealerEdit(params)
      let { results } = res
      if (results.code === 0) {
        this.$message({
          type: 'success',
          message: '修改成功'
        })
        this.saveStatus = true
        this.params.confirm_password = ''
        this.params.password = ''
        this.loadUserData()
      } else {
        this.$message({
          type: 'error',
          message: results.msg
        })
      }
    }
  },
  created () {
    this.type = this.$route.query.type || ''
    this.id = this.$route.query.id || 0
    this.loadUserData()
  }
}
</script>

<style lang="scss" scoped>
.section {
  margin: 13px 23px;
}
</style>
